<template>
  <div class="customer-select-container">
    <el-select
            v-model="currentValue"
            v-bind="$attrs"
            v-on="$listeners"
            filterable
            default-first-option
            :collapse-tags="true"
            :filter-method="searchCustomer"
            @visible-change="optionsShowChange"
            @focus="defaultKeyWord"
            placeholder="请输入客户关键词，检索可选客户" style="width: 300px"
            :class="{close:showClose}"
            :size="TypeSize"

    >
      <el-option v-for="item in customerOption" :key="item.id" :label="item.name" :value="item.id"/>
    </el-select>
    <el-button type="text" v-show="showClose" @click.native="clear" class="close-btn">
      <i class="el-select__caret el-input__icon el-icon-circle-close"/>
    </el-button>
  </div>

</template>

<script>
import {customerSearch} from "@/api/customers";

export default {
  name: "CustomerRemoteSelect",
  props: {
    modelValue: {
      type: [Array, String, Number],
      default() {
        return null
      }
    },
    TypeSize: {
      type: String,
      default: ""
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.emitData = val
        this.$emit('update:modelValue', val)
      }
    },
  },
  data() {
    return {
      customerOption: [],
      values: [],
      cacheKey: 'c:crs-keyword',
      showClose: false,
      emitData: {}
    }
  },
  methods: {
    async searchCustomer(queryString) {
      if (queryString) {
        localStorage.setItem(this.cacheKey, queryString)
        const list = await customerSearch({search: queryString}).then((res) => {
          return res.model.data
        })
        this.$nextTick(() => {
          this.customerOption = list
        })
      }
    },
    defaultKeyWord() {
      let cacheValue = localStorage.getItem(this.cacheKey)
      // this.$notify.info(cacheValue)
      this.searchCustomer(cacheValue)
    },
    optionsShowChange(v) {
      this.showClose = v
    },
    clear() {
      this.$emit('update:modelValue', [])
    },
    getOptionValue() {
      return this.customerOption.find((item) => item.id === this.emitData)

    }

  }
}
</script>

<style lang="scss">
.customer-select-container {
  position: relative;

  .close-btn {
    right: 5px;
    top: -18px;
    position: absolute;
    cursor: pointer !important;
    z-index: 9999;
    color: #C0C4CC;
    font-size: 14px;
  }

  .close {
    .el-icon-arrow-up {
      display: none;
    }
  }
}
</style>
